'use client';
import { useEffect } from 'react';
 
const useEqualHeight = (classNames: string[], delay: number = 100) => {
  const equalHeight = () => {
    classNames.forEach((className) => {
      const elements = Array.from(
        document.getElementsByClassName(className)
      ) as HTMLElement[];
 
      if (!elements.length) return;
 
      // Reset to auto height
      elements.forEach(el => {
        el.style.height = 'auto';
      });
 
      // Get max height across all
      const maxHeight = Math.max(...elements.map(el => el.offsetHeight));
 
      // Set all to max height
      elements.forEach(el => {
        el.style.height = `${maxHeight}px`;
      });
    });
  };
 
  useEffect(() => {
    const delayedEqualHeight = () => {
      setTimeout(equalHeight, delay); // wait for DOM to fully render
    };
 
    delayedEqualHeight();
 
    window.addEventListener('resize', delayedEqualHeight);
    return () => window.removeEventListener('resize', delayedEqualHeight);
  }, [classNames, delay]);
 
  return equalHeight;
};
 
export default useEqualHeight;
 
 
 